import { API_URL, STORE_API_URL, PROJECT_URL, request, getAuthToken } from "./axiosInstance";
// ARCH-5: storefront catalog reads go through the unauthenticated Store API.
// See Api/storeApi.js for the two non-optional conversions (minor-unit prices,
// and sale_price inverting in meaning).
import {
    fetchStoreProducts,
    fetchStoreProductById,
    fetchStoreCategories,
} from "./storeApi";
import axios from 'axios';
import pLimit from 'p-limit';
import { getAllCachedProducts,saveProducts ,getProductsLastUpdated} from "./productDB";
const PRODUCT_TTL = 1000 * 60 * 15; // 15 minutes

/*const LOCAL_KEY = "all_products_cache";
const LOCAL_TIME_KEY = "all_products_cache_time";
const TTL = 1000 * 60 * 60 * 6; // 6 hours*/



const limit = pLimit(5);

// Get all products by page
export async function getAllProductsByPage(page = 1, per_page = 8) {
    try {
        // ARCH-5: unauthenticated Store API. Returns the same
        // { data, total, totalPages } envelope; `headers` is dropped because no
        // caller read it (checked across pages/ and components/).
        return await fetchStoreProducts({ page, per_page });
    } catch (error) {
        console.error('Error fetching products:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        return { data: [], total: 0, totalPages: 1 };
    }
}

// Get category id by slug
/*
export async function getCategoryBySlug(slug) {
    try {
        const response = await request('GET', `${API_URL}/products/categories`, {}, {
            search: decodeURIComponent(slug),
            per_page: 30,
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching category by slug:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        return null;
    }
}*/
const CATEGORY_CACHE_KEY = "category_slug_map";

export async function getCategoryBySlug(slug) {
  try {
    //  Read cache
    const cached = localStorage.getItem(CATEGORY_CACHE_KEY);
    if (cached) {
      const map = JSON.parse(cached);
      if (map[slug]) {
        return map[slug];
      }
    }

    // Fetching categories — ARCH-5: unauthenticated Store API. This drops the
    // last storefront need for `manage_product_terms`, which wc/v3 requires
    // merely to *list* categories. See the note in Api/categories.js for what
    // that capability does and does not actually grant.
    const response = await fetchStoreCategories({ per_page: 100 });

    const slugMap = {};
    response.data.forEach(cat => {
      slugMap[cat.slug] = cat;
    });

    //  Storing full map
    localStorage.setItem(CATEGORY_CACHE_KEY, JSON.stringify(slugMap));

    return slugMap[slug] || null;

  } catch (err) {
    console.error("Category slug fetch failed", err);
    return null;
  }
}

/*
// Get products by category ID
export async function getProductsByCategoryId(categoryId, page = 1, perPage = 30) {
    try {
        // ARCH-5: unauthenticated Store API.
        return await fetchStoreProducts({
            category: categoryId,
            page,
            per_page: perPage,
        });
    } catch (error) {
        console.error('Error fetching products by category:', {
            categoryId,
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        return { data: [], total: 0, totalPages: 1 };
    }
}*/

/*export function getCachedProductsByCategory(categoryId) {
  const cached = localStorage.getItem("all_products_cache");
  if (!cached) return [];

  const products = JSON.parse(cached);

  return products.filter(product =>
    product.categories?.some(cat => cat.id === categoryId)
  );
}*/
export async function getCachedProductsByCategory(categoryId) {
  const products = await getAllCachedProducts();
  return products.filter(product =>
    product.categories?.some(cat => cat.id === categoryId)
  );
}

// all products by slug
export async function getProductBySlug(query) {
    try {
        // ARCH-5: unauthenticated Store API. Returns the array directly, as before.
        const { data } = await fetchStoreProducts({
            search: decodeURIComponent(query),
            per_page: 30,
        });
        return data;
    } catch (error) {
        console.error('Error fetching product by slug:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to fetch product by slug');
    }
}

// Get all products
{/*export async function getAllProducts() {
    try {
        const response = await request('GET', `${API_URL}/products`);
        return response.data;
    } catch (error) {
        console.error('Error fetching all products:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to fetch all products');
    }
}*/}

{/*export async function getAllProducts() {
  try {
    const perPage = 100;

    // Fetch the first page to determine total pages
    const firstResponse = await catalogRequest('GET', `${API_URL}/products`, {}, { page: 1, per_page: perPage });
    const totalPages = parseInt(firstResponse.headers?.['x-wp-totalpages'] || 1, 10);

    // Create array of promises for each page fetch
    const fetchPromises = [];
    for (let page = 1; page <= totalPages; page++) {
      fetchPromises.push(limit(()=>request('GET', `${API_URL}/products`, {}, { page, per_page: perPage })));
    }

    // Fetching all pages in parallel
    const responses = await Promise.all(fetchPromises);

    // Combine all products from responses
    const allProducts = responses.flatMap(res => res.data);

    return allProducts;

  } catch (error) {
    console.error('Error fetching all products:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
    });
    throw new Error(error.response?.data?.message || 'Failed to fetch all products');
  }
}*/}

{/*export async function getAllProducts() {
    try {
        const perPage = 100; 
        let page = 1;
        let allProducts = [];
        let totalPages = 1;

        do {
            const response = await catalogRequest('GET', `${API_URL}/products`, {}, { page, per_page: perPage });

            allProducts = [...allProducts, ...response.data];

            totalPages = parseInt(response.headers?.['x-wp-totalpages'] || 1, 10);
            page++;
        } while (page <= totalPages);

        return allProducts;
    } catch (error) {
        console.error('Error fetching all products:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to fetch all products');
    }
}*/}

{/*export async function getAllProducts() {
  try {
    const perPage = 100;

    // First call — to get total pages
    const firstResponse = await catalogRequest('GET', `${API_URL}/products`, {}, { page: 1, per_page: perPage });
    const totalPages = parseInt(firstResponse.headers?.['x-wp-totalpages'] || 1, 10);

    // Use concurrency limit (e.g., 10 parallel requests)
    const limit = pLimit(10);
    const fetchPromises = [];

    for (let page = 1; page <= totalPages; page++) {
      fetchPromises.push(limit(() => request('GET', `${API_URL}/products`, {}, { page, per_page: perPage })));
    }

    // Process in batches for faster speed but avoid rate-limit
    const responses = await Promise.all(fetchPromises);
    const allProducts = responses.flatMap(res => res.data);

    return allProducts;
  } catch (error) {
    console.error('Error fetching all products:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
    });
    throw new Error(error.response?.data?.message || 'Failed to fetch all products');
  }
}*/}



 /*export async function getAllProducts() {
  try {
    //  LocalStorage cache 
    const cachedData = localStorage.getItem(LOCAL_KEY);
    const cachedTime = localStorage.getItem(LOCAL_TIME_KEY);

    if (cachedData) {
      console.log(" Loading products instantly from LocalStorage");
       const parsed = JSON.parse(cachedData);
      // If cache is old — refresh async
      if (!cachedTime || Date.now() - cachedTime > TTL) {
        console.log(" Starting background refresh...");
        refreshProductsInBackground();
      }

      return JSON.parse(cachedData);
    }

    //  fetch from WooCommerce
    console.log(" No local cache → Full fetch from WooCommerce");
    const products = await fetchProductsFromWooCommerce();

    // save in localStorage for next INSTANT load
    localStorage.setItem(LOCAL_KEY, JSON.stringify(products));
    localStorage.setItem(LOCAL_TIME_KEY, Date.now().toString());

    return products;

  } catch (error) {
    console.error("Error fetching all products:", error);
    throw error;
  }
}*/

/*export async function getAllProducts() {
  try {
    const cachedData = localStorage.getItem(LOCAL_KEY);
    const cachedTime = localStorage.getItem(LOCAL_TIME_KEY);

    if (cachedData) {
      const parsed = JSON.parse(cachedData);

      
      if (Array.isArray(parsed) && parsed.length > 0) {
        console.log(" Using cached products:", parsed.length);

        // Refresh in background if stale
        if (!cachedTime || Date.now() - cachedTime > TTL) {
          refreshProductsInBackground();
        }

        return parsed;
      }

      console.warn(" Cache exists but EMPTY — refetching");
    }

    //  FETCH FROM API
    const products = await fetchProductsFromWooCommerce();

    localStorage.setItem(LOCAL_KEY, JSON.stringify(products));
    localStorage.setItem(LOCAL_TIME_KEY, Date.now().toString());

    return products;

  } catch (error) {
    console.error("getAllProducts failed:", error);
    return [];
  }
}*/


/*
export async function getAllProducts() {
  try {
    // 1️ Try IndexedDB first
    const cached = await getAllCachedProducts();

    if (cached && cached.length > 0) {
      console.log(" Loaded products from IndexedDB:", cached.length);
      return cached;
    }

    // 2️ Fetch from WooCommerce
    console.log(" No IndexedDB cache → fetching from API");
    const products = await fetchProductsFromWooCommerce();

    // 3 Save to IndexedDB
    await saveProducts(products);

    return products;

  } catch (error) {
    console.error("getAllProducts failed:", error);
    return [];
  }
}*/

export async function getAllProducts() {
  try {
    const cached = await getAllCachedProducts();
    const lastUpdated = await getProductsLastUpdated();

  
    if (!cached || cached.length === 0) {
      console.log("IndexedDB empty → fetching from API");

      const products = await fetchProductsFromWooCommerce();
      await saveProducts(products);
        const fresh = await getAllCachedProducts();
  return fresh;
      
    }

    const age = Date.now() - lastUpdated;

    if (age > PRODUCT_TTL) {
      console.log("Cache stale → refreshing in background");
      refreshProductsInBackground(); // non-blocking
    }

    console.log("Using IndexedDB cache:", cached.length);
    return cached;

  } catch (err) {
    console.error("getAllProducts failed:", err);
    return [];
  }
}



//refreshing products
/*async function refreshProductsInBackground() {
  try {
    const freshData = await fetchProductsFromWooCommerce();

    localStorage.setItem(LOCAL_KEY, JSON.stringify(freshData));
    localStorage.setItem(LOCAL_TIME_KEY, Date.now().toString());

    console.log(" Background refresh completed");
  } catch (err) {
    console.log(" Background refresh failed:", err.message);
  }
}*/
async function refreshProductsInBackground() {
  try {
    const freshData = await fetchProductsFromWooCommerce();
    await saveProducts(freshData);
    console.log(" Background refresh completed (IndexedDB)");
  } catch (err) {
    console.log(" Background refresh failed:", err.message);
  }
}

async function fetchProductsFromWooCommerce() {
  const perPage = 100;

  // ARCH-5: unauthenticated Store API throughout. The adaptive-concurrency and
  // first-page-latency logic is kept as-is; only the transport changed.
  //
  // Note the first page was already on the shared catalog helper but the loop
  // below still used the signed-in user's `request`, so a signed-in customer hit
  // the 403 from BUG-13 on pages 2..n while page 1 succeeded — a partially
  // populated catalog rather than an empty one. Both now take the same path, and
  // that path needs no credential at all.
  const startTime = Date.now();
  const first = await fetchStoreProducts({ page: 1, per_page: perPage });

  const totalPages = first.totalPages || 1;
  const latency = Date.now() - startTime;

  let concurrency = 5;
  if (latency < 500) concurrency = 15;
  else if (latency < 1000) concurrency = 10;
  else if (latency < 2000) concurrency = 7;

  const limit = pLimit(concurrency);
  const fetchPromises = [];

  // Page 1 is already in hand — refetching it was wasted work.
  for (let page = 2; page <= totalPages; page++) {
    fetchPromises.push(
      limit(() =>
        fetchStoreProducts({ page, per_page: perPage })
          .then((res) => res.data)
          .catch((err) => {
            console.warn(`Page ${page} failed:`, err.message);
            return [];
          })
      )
    );
  }

  const rest = await Promise.all(fetchPromises);
  return [...first.data, ...rest.flat()];
}




// Get single product data by ID
export async function getSingleProductData(productId) {
    try {
        // ARCH-5: unauthenticated Store API.
        return await fetchStoreProductById(productId);
    } catch (error) {
        console.error('Error fetching single product:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to fetch single product');
    }
}
// Delete product by ID
export async function deleteProductById(productId) {
    try {
        return await request('DELETE', `${API_URL}/products/${productId}`, {}, { force: true });
    } catch (error) {
        console.error('Error deleting product:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to delete product');
    }
}
// Add product to store
export async function addProductToStore(data) {
    try {
        return await request('POST', `${API_URL}/products`, data);
    } catch (error) {
        console.error('Error adding product:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to add product');
    }
}
// Update product
export async function updateProductById(productId, data) {
    try {
        return await request('PUT', `${API_URL}/products/${productId}`, data);
    } catch (error) {
        console.error('Error updating product:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to update product');
    }
}
// Get review to product
// Reads reviews from the PUBLIC Store API rather than wc/v3.
//
// wc/v3/products/reviews requires the `moderate_comments` capability, which also
// permits DELETING comments — far too much for the shared anonymous account whose
// credentials ship in this bundle. The Store API needs no authentication at all and
// returns the same fields this UI renders (id, rating, review, reviewer).
// See SEC-20 in Frontend/docs/REMEDIATION_BACKLOG.md.
export async function getProductReview(productId) {
    try {
        return await axios.get(`${STORE_API_URL}/products/reviews`, {
            params: {
                product_id: productId,
                per_page: 100,
                page: 1,
                order: 'desc',
                orderby: 'date',
            },
        });
    } catch (error) {
        console.error('Error fetching reviews:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to fetch reviews');
    }
}

// Add review to product
// Submit a product review via custom/v1/reviews.
//
// Previously POSTed to wc/v3/products/reviews, which needs `moderate_comments` — a
// capability that also allows DELETING comments, so it was never appropriate for the
// storefront. The replacement takes the reviewer name and email from the signed-in
// account rather than the request, enforces one review per product per user, and
// creates the review UNAPPROVED so moderation stays with the store.
export async function addReviewToProduct(data) {
    const token = await getAuthToken();
    try {
        const response = await axios.post(
            `${PROJECT_URL}wp-json/custom/v1/reviews`,
            {
                product_id: data.product_id,
                review: data.review,
                rating: data.rating,
                // reviewer / reviewer_email are deliberately not sent: the server
                // uses the authenticated account, so a review cannot be attributed
                // to someone else.
            },
            { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
        );
        return response;
    } catch (error) {
        console.error('Error adding review:', {
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to add review');
    }
}

const CATEGORY_PRODUCT_TTL = 1000 * 60 * 10; // 10 minutes

export async function getCachedProductsByCategoryId(categoryId, page = 1, perPage = 12) {
  const CACHE_KEY = `cat_products_${categoryId}_${page}_${perPage}`;
  const TIME_KEY = `${CACHE_KEY}_time`;

  const cached = localStorage.getItem(CACHE_KEY);
  const cachedTime = localStorage.getItem(TIME_KEY);

  //  Return fresh cache
  if (cached && cachedTime && Date.now() - cachedTime < CATEGORY_PRODUCT_TTL) {
    return JSON.parse(cached);
  }

  //  Fetch from the Store API (ARCH-5)
  const response = await fetchStoreProducts({
    category: categoryId,
    page,
    per_page: perPage,
  });

  const result = {
    data: response.data,
    totalPages: response.totalPages || 1,
  };

  //  Save cache
  localStorage.setItem(CACHE_KEY, JSON.stringify(result));
  localStorage.setItem(TIME_KEY, Date.now().toString());

  return result;
}